import { graphql } from "../gql";

export const createAskAutodorSavedPromptMutationDoc = graphql(`
  mutation createAskAutodorSavedPrompt(
    $input: AskAutodorCreateSavedPromptInput!
  ) {
    askAutodorCreateSavedPrompt(input: $input) {
      savedPromptId
    }
  }
`);
